import React, { FC } from "react";
import { SVGProps } from "react";

export interface IconProps extends SVGProps<SVGSVGElement> {
    size?: number;
}

export const SettingsIcon: FC<IconProps> = (props) => {
    const { size = 16.75, viewBox, ...rest } = props;
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={`${size}px`}
            height={`${size}px`}
            fill="white"
            fillOpacity={0.54}
            viewBox={`0 0 16.75 16.75`}
            {...rest}
        >
            <path d="M6.64583 17.3333L6.33333 14.7083C6.19444 14.625 6.04167 14.5347 5.875 14.4375C5.70833 14.3403 5.55556 14.25 5.41667 14.1667L2.97917 15.1875L0.625 11.125L2.70833 9.54166V8.45832L0.625 6.87499L2.97917 2.81249L5.41667 3.83332C5.55556 3.74999 5.70833 3.65971 5.875 3.56249C6.04167 3.46527 6.19444 3.37499 6.33333 3.29166L6.64583 0.666656H11.3542L11.6667 3.29166C11.8056 3.37499 11.9583 3.46527 12.125 3.56249C12.2917 3.65971 12.4444 3.74999 12.5833 3.83332L15.0208 2.81249L17.375 6.87499L15.3125 8.45832V9.54166L17.375 11.125L15.0208 15.1875L12.5833 14.1667C12.4444 14.25 12.2917 14.3403 12.125 14.4375C11.9583 14.5347 11.8056 14.625 11.6667 14.7083L11.3542 17.3333H6.64583ZM9 11.9792C9.81944 11.9792 10.5208 11.6875 11.1042 11.1042C11.6875 10.5208 11.9792 9.81943 11.9792 8.99999C11.9792 8.18054 11.6875 7.47916 11.1042 6.89582C10.5208 6.31249 9.81944 6.02082 9 6.02082C8.18055 6.02082 7.47917 6.31249 6.89583 6.89582C6.3125 7.47916 6.02083 8.18054 6.02083 8.99999C6.02083 9.81943 6.3125 10.5208 6.89583 11.1042C7.47917 11.6875 8.18055 11.9792 9 11.9792Z"/>
        </svg>
    );
};
